$(document).ready(function () {
	window.myDataLayer = getShoptetDataLayer();

	$(".product input[name='amount']").attr({
		type: 'number',
		min: 1,
		max: 99,
		step: 1,
	});
});

document.addEventListener('ShoptetDOMContentLoaded', function () {
	$(".product input[name='amount']").attr({
		type: 'number',
		min: 1,
		max: 99,
		step: 1,
	});
});
